const shouldBeEncoded = (str) => {
  const delimitersRegExp = /[:/?#\[\]@]/g;
  const subdelimitersRegExp = /[!$&\\()*+,;=]/g;
  return !!str.match(delimitersRegExp) || !!str.match(subdelimitersRegExp);
};

const isValidParam = (param) => {
  const matchesEqual = param.match(/=/);
  return !!matchesEqual && matchesEqual.length === 1;
};

const extractValuesFromParams = (params) => {
  const values = params.replace(/^\?/, '').split('&').reduce((memo, param) => {
    if (!isValidParam(param)) return memo;
    const [key, val] = param.split('=');
    if (shouldBeEncoded(val)) return memo;
    return { ...memo, [key]: decodeURIComponent(val) };
  }, {});
  if (!Object.keys(values).length) return undefined;
  return values;
};

const extractValueFromParams = (key, params) => {
  const matcherSuffix = '=([^&]*)';
  const keyRegexp = new RegExp(`${key}${matcherSuffix}`);
  const match = keyRegexp.exec(params);
  if (!match) return match;
  const val = match[1];
  if (shouldBeEncoded(val)) return undefined;
  return decodeURIComponent(val);
};

export const getAll = (params = window.location.search) => {
  if (!!params.length) return extractValuesFromParams(params);
  return undefined;
};

export const get = (key, params = window.location.search) => {
  if (!!params.length) return extractValueFromParams(key, params);
  return undefined;
};

export default {
  get,
  getAll,
};



/** WEBPACK FOOTER **
 ** ./modules/query-params/index.js
 **/